var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('b-button',{attrs:{"size":"lg","variant":"info"},on:{"click":function($event){return _vm.$emit('enter')}}},[_vm._v("Hívás rögzítése")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }